
import { api_host,api_auth} from '../../common/globals/constants';

export const getClientWeighing = (user, token, type) => 
fetch(api_host+`/reporte/general/cliente_ponderacion/?token=${token}&user=${user}`)
.then(response => response.json())
